import Joi from 'joi';
const showGlobalAlertBannerEventPayloadSchema = Joi.object({
    alertMessage: Joi.string()
        .max(200)
        .required(),
    labelTranslation: Joi.string()
        .max(200)
        .optional(),
    type: Joi.string()
        .valid('info', 'warning', 'error', 'success')
        .optional(),
    showCloseButton: Joi.boolean().optional(),
}).unknown(false);
export const validateShowGlobalAlertBannerEventPayloadObject = (object) => {
    try {
        Joi.assert(object, showGlobalAlertBannerEventPayloadSchema);
    }
    catch (err) {
        throw new Error(err.details[0].message);
    }
};
//# sourceMappingURL=utils.js.map